import React from 'react';
import { formatCurrency, formatDate } from '../../lib/utils';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { StatementHeader } from './ReportHelpers';

export function GeneralLedgerReport({ reportData, viewMode, entityName }) {
  if (!reportData) return null;
  const accounts = reportData.accounts || [];

  if (viewMode === 'list') {
    return (
      <Card data-testid="gl-list-view">
        <CardContent className="py-8 px-6">
          <StatementHeader entityName={entityName} title="General Ledger" period={reportData.period} />
          {accounts.length === 0 ? (
            <p className="text-center text-zinc-400 py-8">No ledger entries for this period</p>
          ) : accounts.map(account => (
            <div key={account.account_code} className="mb-8">
              <h3 className="text-sm font-semibold text-zinc-800 border-b-2 border-zinc-800 pb-1 mb-0">
                {account.account_code} — {account.account_name}
              </h3>
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-zinc-300 bg-zinc-50/50">
                    <th className="py-1.5 px-3 text-left text-xs font-semibold text-zinc-500 w-24">Date</th>
                    <th className="py-1.5 px-3 text-left text-xs font-semibold text-zinc-500 w-12">#</th>
                    <th className="py-1.5 px-3 text-left text-xs font-semibold text-zinc-500">Description</th>
                    <th className="py-1.5 px-3 text-right text-xs font-semibold text-zinc-500 w-28">Debit</th>
                    <th className="py-1.5 px-3 text-right text-xs font-semibold text-zinc-500 w-28">Credit</th>
                    <th className="py-1.5 px-3 text-right text-xs font-semibold text-zinc-500 w-28 pr-4">Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {(account.entries || []).map(e => (
                    <tr key={`${account.account_code}-${e.entry_number}`} className="border-b border-zinc-200 hover:bg-zinc-50/30">
                      <td className="py-1.5 px-3 text-zinc-500 font-mono text-xs">{formatDate(e.date)}</td>
                      <td className="py-1.5 px-3 font-mono text-xs text-zinc-400">{e.entry_number}</td>
                      <td className="py-1.5 px-3 text-zinc-700">{e.description}</td>
                      <td className="py-1.5 px-3 text-right font-mono tabular-nums">{e.debit > 0 ? formatCurrency(e.debit) : '-'}</td>
                      <td className="py-1.5 px-3 text-right font-mono tabular-nums">{e.credit > 0 ? formatCurrency(e.credit) : '-'}</td>
                      <td className={`py-1.5 px-3 text-right font-mono tabular-nums pr-4 ${e.running_balance < 0 ? 'text-red-600' : ''}`}>{formatCurrency(e.running_balance)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {accounts.length === 0 ? (
        <Card><CardContent className="py-12 text-center text-zinc-500">No ledger entries for this period</CardContent></Card>
      ) : accounts.map(account => (
        <Card key={account.account_code}>
          <CardHeader className="py-3"><CardTitle className="text-base flex items-center gap-2"><span className="font-mono text-zinc-500">{account.account_code}</span>{account.account_name}</CardTitle></CardHeader>
          <CardContent className="p-0">
            <table className="report-table">
              <thead><tr><th className="w-28 pl-4">Date</th><th className="w-16">#</th><th>Description</th><th className="text-right w-28">Debit</th><th className="text-right w-28">Credit</th><th className="text-right w-28 pr-4">Balance</th></tr></thead>
              <tbody>
                {(account.entries || []).map(e => (
                  <tr key={`${account.account_code}-${e.entry_number}`}><td className="text-zinc-500 pl-4">{formatDate(e.date)}</td><td className="font-mono text-zinc-400">#{e.entry_number}</td><td>{e.description}</td><td className="text-right font-mono">{e.debit > 0 ? formatCurrency(e.debit) : '-'}</td><td className="text-right font-mono">{e.credit > 0 ? formatCurrency(e.credit) : '-'}</td><td className={`text-right font-mono pr-4 ${e.running_balance < 0 ? 'text-red-600' : ''}`}>{formatCurrency(e.running_balance)}</td></tr>
                ))}
              </tbody>
            </table>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
